import React from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router';
import { routes } from '@/constants/routes.const';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { IMG_LOGO_KTP_BLUE, IMG_LOGO_KTP_WHITE } from '@repo/assets';
import { isRefundableAirport } from '@repo/utils';

interface IProps {
  isTop: boolean;
  isMobile?: boolean;
}
function Logo({ isTop, isMobile }: IProps) {
  const { departureDate, airportRefundable, passportNumber } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const { pathname } = useLocation();
  const history = useHistory();

  const onClick = () => {
    if (
      pathname === '/select-airport' ||
      pathname === '/airport-non-refundable'
    ) {
      return;
    }
    // 처음 화면
    if (airportRefundable) {
      const isTransferWeb =
        localStorage.getItem(`${passportNumber}-transfer`) === 'true';
      if (isTransferWeb) {
        if (departureDate) {
          history.replace(routes.home);
        } else {
          history.replace('/departure');
        }
        return;
      }
      if (passportNumber) {
        if (isRefundableAirport(localStorage.getItem(passportNumber))) {
          history.replace(routes.airport);
          return;
        }
        if (!!localStorage.getItem(passportNumber)) {
          if (departureDate) {
            history.replace(routes.home);
          } else {
            history.replace('/departure');
          }
          return;
        }
      }
      history.replace(routes.selectAirport);
      return;
    }
    if (pathname === '/' || pathname === '/medical') {
      return;
    }
    if (departureDate) {
      history.replace(routes.home);
    }
    window.scrollTo(0, 0);
  };
  return (
    <LogoWrapper isMobile={isMobile}>
      <SLogo
        alt='Korea Tax Free Payments'
        src={isTop ? IMG_LOGO_KTP_WHITE : IMG_LOGO_KTP_BLUE}
        onClick={onClick}
      />
    </LogoWrapper>
  );
}

const LogoWrapper = styled.div<{ isMobile?: boolean }>`
  position: relative;
  width: 80px;
  height: 22px;
`;

const SLogo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`;
export default Logo;
